// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Reducer$LiteracyplanetTupperware from "./Reducer.res.mjs";

function findOne(questionIndex, states, $$default) {
  return Belt_List.reduce(states, $$default, (function (acc, param) {
                if (param[1] === questionIndex) {
                  return param[0];
                } else {
                  return acc;
                }
              }));
}

function findMarkState(questionIndex, markStates) {
  return findOne(questionIndex, markStates, "NotMarked");
}

function findQuestionState(questionIndex, questionStates) {
  return findOne(questionIndex, questionStates, "NotAttempted");
}

function updateList(questionIndex, states, state) {
  var exists = Belt_List.reduce(states, false, (function (acc, param) {
          if (param[1] === questionIndex) {
            return true;
          } else {
            return acc;
          }
        }));
  if (exists) {
    return Belt_List.reduce(states, /* [] */0, (function (acc, param) {
                  var index = param[1];
                  if (index === questionIndex) {
                    return Belt_List.concat(acc, {
                                hd: [
                                  state,
                                  index
                                ],
                                tl: /* [] */0
                              });
                  } else {
                    return Belt_List.concat(acc, {
                                hd: [
                                  param[0],
                                  index
                                ],
                                tl: /* [] */0
                              });
                  }
                }));
  } else {
    return Belt_List.concat({
                hd: [
                  state,
                  questionIndex
                ],
                tl: /* [] */0
              }, states);
  }
}

function notMarked(state, questionIndex) {
  var markState = findOne(questionIndex, state.markStates, "NotMarked");
  if (typeof markState !== "object") {
    return true;
  } else {
    return false;
  }
}

function setQuestionState(questionIndex, responsePayload, state, questionMarking) {
  if (!notMarked(state, questionIndex)) {
    return state;
  }
  var questionState = findOne(questionIndex, state.questionStates, "NotAttempted");
  var newQuestionState = Reducer$LiteracyplanetTupperware.respondToQuestion(questionState, responsePayload, questionMarking);
  var questionStates = updateList(questionIndex, state.questionStates, newQuestionState);
  return {
          questionStates: questionStates,
          markStates: state.markStates,
          mode: state.mode,
          questionsComplete: state.questionsComplete,
          questionsCorrect: state.questionsCorrect,
          questionsIncorrect: state.questionsIncorrect,
          hasResponseMarking: state.hasResponseMarking
        };
}

function deleteResponseIdentifier(questionIndex, responseIdentifier, state) {
  if (!notMarked(state, questionIndex)) {
    return state;
  }
  var questionState = findOne(questionIndex, state.questionStates, "NotAttempted");
  var newQuestionState = Reducer$LiteracyplanetTupperware.filterResponseIdentifier(questionState, responseIdentifier);
  var questionStates = updateList(questionIndex, state.questionStates, newQuestionState);
  return {
          questionStates: questionStates,
          markStates: state.markStates,
          mode: state.mode,
          questionsComplete: state.questionsComplete,
          questionsCorrect: state.questionsCorrect,
          questionsIncorrect: state.questionsIncorrect,
          hasResponseMarking: state.hasResponseMarking
        };
}

function setMarkState(questionIndex, newMarkState, state, questionCorrect) {
  if (!notMarked(state, questionIndex)) {
    return state;
  }
  var questionsCorrect = questionCorrect ? state.questionsCorrect + 1 | 0 : state.questionsCorrect;
  var questionsIncorrect = questionCorrect ? state.questionsIncorrect : state.questionsIncorrect + 1 | 0;
  var markStates = updateList(questionIndex, state.markStates, newMarkState);
  return {
          questionStates: state.questionStates,
          markStates: markStates,
          mode: state.mode,
          questionsComplete: state.questionsComplete + 1 | 0,
          questionsCorrect: questionsCorrect,
          questionsIncorrect: questionsIncorrect,
          hasResponseMarking: state.hasResponseMarking
        };
}

function markQuestion(state, fuzzyMark, correctAnswer, questionIndex) {
  var questionState = findOne(questionIndex, state.questionStates, "NotAttempted");
  var answer = fuzzyMark ? ({
        TAG: "AnswerFuzzyMatch",
        _0: correctAnswer
      }) : ({
        TAG: "AnswerExactMatch",
        _0: correctAnswer
      });
  var match = Reducer$LiteracyplanetTupperware.markQuestion(questionState, answer);
  return setMarkState(questionIndex, match[1], state, match[0]);
}

var initialState = {
  questionStates: /* [] */0,
  markStates: /* [] */0,
  mode: "Activity",
  questionsComplete: 0,
  questionsCorrect: 0,
  questionsIncorrect: 0,
  hasResponseMarking: true
};

function reducer(state, action) {
  if (typeof action !== "object") {
    return initialState;
  }
  switch (action.TAG) {
    case "SetStore" :
        return action._0;
    case "SetMode" :
        return {
                questionStates: state.questionStates,
                markStates: state.markStates,
                mode: action._0,
                questionsComplete: state.questionsComplete,
                questionsCorrect: state.questionsCorrect,
                questionsIncorrect: state.questionsIncorrect,
                hasResponseMarking: state.hasResponseMarking
              };
    case "SetQuestionState" :
        return setQuestionState(action._0, action._1, state, state.hasResponseMarking ? action._2 : "QuestionMarking");
    case "DeleteResponseIdentifier" :
        return deleteResponseIdentifier(action._0, action._1, state);
    case "MarkQuestion" :
        return markQuestion(state, action._0, action._1, action._2);
    
  }
}

export {
  findOne ,
  findMarkState ,
  findQuestionState ,
  updateList ,
  notMarked ,
  setQuestionState ,
  deleteResponseIdentifier ,
  setMarkState ,
  markQuestion ,
  initialState ,
  reducer ,
}
/* No side effect */
